import { render, staticRenderFns } from "./WebTargeting.vue?vue&type=template&id=f7b74620&"
import script from "./WebTargeting.vue?vue&type=script&lang=js&"
export * from "./WebTargeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports